import React, { useCallback, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useUnmount } from 'react-use';
import get from 'lodash/get';

import { formSelector } from '@xcritical/forms';
import Button from '@xcritical/button';
import Modal, {
  xcriticalModalOpen,
  xcriticalModalClose,
  IStoreWithModal,
  getModalByName,
} from '@xcritical/modal';

import { PROMO_FORM_NAME, PROMO_MODAL_NAME } from '../../consts';
import { IPromoModalProps } from '../../types';

export const PreviewModal = ({ path, languageName }: IPromoModalProps) => {
  const dispatch = useDispatch();
  const iframeRef = useRef<HTMLIFrameElement>(null);

  const { emailBody, isOpen, disabledModal } = useSelector(
    (state: IStoreWithModal) => {
      const modal = getModalByName(state, PROMO_MODAL_NAME);
      const form = formSelector(state, PROMO_FORM_NAME);
      const $emailBody = get(form, ['model', ...path.split('.')], '');

      return {
        disabledModal: !$emailBody,
        emailBody: $emailBody,
        isOpen: modal.isOpen,
      };
    }
  );

  useUnmount(() => dispatch(xcriticalModalClose(PROMO_MODAL_NAME)));

  const onModalOpen = useCallback(() => {
    dispatch(xcriticalModalOpen(PROMO_MODAL_NAME));
  }, []);

  const onModalClose = useCallback(() => {
    dispatch(xcriticalModalClose(PROMO_MODAL_NAME));
  }, []);

  useEffect(() => {
    if (isOpen) {
      // eslint-disable-next-line no-unused-expressions
      iframeRef.current?.contentDocument?.write(emailBody);
    }
  }, [isOpen]);

  return (
    <>
      <Button onClick={onModalOpen} appearance="link" disabled={disabledModal}>
        Preview
      </Button>
      <Modal
        name={PROMO_MODAL_NAME}
        title={`Promo Email Preview (${languageName})`}
        width="730px"
        minWidth="730px"
        isOpen={isOpen}
        onModalCancel={onModalClose}>
        <iframe
          title={`Promo Email Preview (${languageName})`}
          height={document.documentElement.offsetHeight - 200}
          width={700}
          ref={iframeRef}
        />
      </Modal>
    </>
  );
};
